import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblBadge from '@/components/bui/atoms/TblBadge/TblBadge.vue';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormatDateOnly from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormatDateOnly.vue';
import UsedBy from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/UsedBy.vue';

const playerSubscriptionsColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          {
            to: `/player-subscriptions/edit/${item.id}`,
            class: 'title-link',
            'data-testid': 'list-row-title',
            onClick: (e: MouseEvent) => e.stopPropagation(),
          },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.description ?? ''),
      ]),
  },
  {
    key: 'modified',
    kind: 'text',
    label: 'Modified',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateLastModified',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateLastModified }),
  },
  {
    key: 'created',
    kind: 'text',
    label: 'Created',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateCreated',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateCreated }),
  },
  {
    key: 'targetPlayers',
    kind: 'text',
    label: 'Target Players',
    width: 130,
    render: ({ item }) =>
      h(UsedBy, {
        items: (item?.matchedPlayers || []).map((m: any) => m.player),
        label: 'Players',
      }),
  },
  {
    key: 'organizations',
    kind: 'text',
    label: 'Organizations',
    width: 130,
    render: ({ item }) => {
      const orgs = (item?.filters || [])
        .filter((f: any) => f.organization != null)
        .map((f: any) => f.organization);
      return h(UsedBy, { items: orgs, label: 'Organizations' });
    },
  },
  {
    key: 'status',
    kind: 'status',
    label: 'Active',
    width: 100,
    render: ({ item }) =>
      item.isActive ? h(TblBadge, { tone: 'approved' }, () => 'Active') : null,
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default playerSubscriptionsColumns;
